<!-- Sidebar -->
<p-drawer
  [visible]="viewClass()"
  [showCloseIcon]="false"
  position="right"
  [blockScroll]="true"
  [dismissible]="false"
  styleClass="w-full md:w-30rem client-profile-sidebar p-0"
  (onHide)="ClosePopup()"
  appendTo="body"
  [autoZIndex]="true"
>
  <ng-template #headless>
    <!-- Header -->
    <div class="flex border-bottom-1 border-300 surface-0">
      <div class="flex align-items-center">
        <!-- Close Icon -->
        <div
          class="h-3rem w-3rem cursor-pointer surface-200 flex align-items-center justify-content-center -ml-1"
          (click)="ClosePopup()"
        >
          <i class="fa fa-times text-xl text-600"></i>
        </div>
        <!-- Close Icon -->

        <h4 class="mb-0 text-sm p-3 text-green-500">
          {{
            classData().type_name_primary_language ||
              classData().type_name_secondary_language
          }}
        </h4>
      </div>
    </div>
    <!-- Header -->

    @if (
      classData()!.status.toLowerCase() === ClassStatus.Cancelled.toLowerCase()
    ) {
      <div class="-my-3">
        <p-message
          severity="error"
          aria-label="cancelled-warning-icon"
          data-testid="cancelled-warning-icon"
        >
          <div class="p-warn flex align-items-center w-full -m-1">
            <i class="fa fa-exclamation-triangle p-warn text-xl"></i>
            <div class="ml-2 line-height-3 text-sm">
              <strong class="block">{{
                'SCHEDULE.VIEWCLASS.CLASS_CANCELLED' | translate
              }}</strong>
            </div>
          </div>
        </p-message>
      </div>
    }

    <!-- Left Side -->
    <div class="p-3">
      <form [formGroup]="classViewForm">
        <!-- Form Group -->
        <div class="my-3">
          @if (!showSkeleton) {
            <p-select
              [options]="getClassActions"
              formControlName="selectedAction"
              optionLabel="name"
              filterBy="name"
              styleClass="w-full text-sm shadow-2 border-2 border-primary"
              placeholder="{{ 'SCHEDULE.VIEWCLASS.CLASS_ACTION' | translate }}"
              (onChange)="selectAction($event)"
              dropdownIcon="fa fa-chevron-down text-primary"
            >
              <ng-template pTemplate="selectedItem">
                @if (selectedClassAction) {
                  <div class="text-sm flex align-items-center">
                    <i class="{{ selectedClassAction.icon }} text-600 mr-2"></i>
                    <span>{{
                      'SCHEDULE.VIEWCLASS.ACTION.' + selectedClassAction.key
                        | translate
                    }}</span>
                  </div>
                }
              </ng-template>
              <ng-template let-classAction pTemplate="item">
                <div class="text-sm flex align-items-center">
                  <i class="{{ classAction.icon }} text-600 mr-2"></i>
                  <span>{{
                    'SCHEDULE.VIEWCLASS.ACTION.' + classAction.key | translate
                  }}</span>
                </div>
              </ng-template>
            </p-select>
          }
          @if (showSkeleton) {
            <p-skeleton width="100%" height="2.25rem" />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div
          class="mb-2"
          [ngClass]="
            isClassCompletedOrCancelled ? 'opacity-40 pointer-events-none' : ''
          "
        >
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            for="calendar-12h"
            >{{ 'SCHEDULE.VIEWCLASS.LBL_DATETIME' | translate }}</label
          >
          <p-datepicker
            inputId="calendar-12h"
            formControlName="startDate"
            [showTime]="true"
            styleClass="text-sm w-full"
            inputstyleClass="text-sm m-0 border-400 h-2rem border-round"
            [placeholder]="'SCHEDULE.VIEWCLASS.SELECTDATE' | translate"
            [hourFormat]="'12'"
            (onClose)="OnScheduleDateSelect($event)"
          />
          @if (showSkeleton) {
            <p-skeleton width="100%" height="2.25rem" />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (classObj) {
          <div
            class="w-full mb-3"
            [ngClass]="
              isClassCompletedOrCancelled
                ? 'opacity-40 pointer-events-none'
                : ''
            "
          >
            @if (!showSkeleton) {
              <div>
                <!-- Input Field -->
                @if (!RRuleObject.RRule) {
                  <div
                    class="p-input-icon-right w-full text-sm"
                    (click)="showRRule = true"
                  >
                    <div
                      class="p-inputtext p-component p-element cursor-pointer bg-blue-50 w-full"
                    >
                      {{ 'SCHEDULE.VIEWCLASS.REPEAT' | translate }}
                    </div>
                  </div>
                }
                @if (RRuleObject.RRule) {
                  <div class="p-input-icon-right w-full text-sm cursor-pointer">
                    <i
                      class="fa fa-times text-xl text-600"
                      (click)="clearRRule()"
                    ></i>
                    <div
                      class="p-inputtext p-component p-element w-full"
                      (click)="showRRule = true"
                    >
                      {{ RRuleObject.RRuleText || '' }}
                    </div>
                  </div>
                }
                <!-- Input Field -->
              </div>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="2.15rem" />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            for="trainer-selector"
            >{{
              'SCHEDULE.CREATEAPPOINTMENT.LBL_TRAINER' | translate | uppercase
            }}</label
          >
          @if (!showSkeleton) {
            <staff-selector
              [formGroup]="classViewForm"
              [controlName]="SelectedTrainerFormControl"
              [id]="selectedTrainerId"
              [claims]="claims$"
              [styleClass]="'w-full text-sm'"
              [placeHolder]="'SCHEDULE.CREATEAPPOINTMENT.SELECT' | translate"
              (selectedStaff)="getSelectedStaff($event)"
              [filterstaff]="filterStaffIds$"
            />
          }
          @if (showSkeleton) {
            <p-skeleton width="100%" height="2.15rem" />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            for="location-input"
            >{{
              'SCHEDULE.VIEWCLASS.LBL_LOCATION' | translate | uppercase
            }}</label
          >
          @if (!duplicateClass && !showSkeleton) {
            <ff-google-places
              [competitorName]="PlaceNameControl"
              [placeId]="classData().place_id"
              [placeHolderName]="
                'SCHEDULE.VIEWCLASS.SEARCH_LOCATION' | translate
              "
              (fetchPlaceInfo)="getPlaceDetails($event)"
            />
          }
          @if (showSkeleton) {
            <p-skeleton width="100%" height="2.15rem" />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        @if (isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              for="virtual-url-input"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_VIRTUALURL' | translate }}</label
            >
            @if (!showSkeleton) {
              <input
                id="virtual-url-input"
                type="url"
                class="text-sm w-full"
                pInputText
                formControlName="virtualUrl"
                #keyUpInputDelay
                placeholder="{{ 'SCHEDULE.VIEWCLASS.VIRTUALURL' | translate }}"
                (keyup)="onKeyUpDelay(keyUpInputDelay.value)"
              />
            }
            @if (
              VirtualUrlFormControl.touched && VirtualUrlFormControl.invalid
            ) {
              <app-error-msg
                [errors]="VirtualUrlFormControl.errors"
                [fieldLabel]="
                  'SCHEDULE.CREATEAPPOINTMENT.LBL_VIRTUALURL' | translate
                "
              />
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="2.15rem" />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        @if (!isVirtal) {
          <div class="mb-3">
            <label
              class="font-medium text-700 text-xs mb-2 block uppercase"
              for="room-selector"
              >{{ 'SCHEDULE.VIEWCLASS.LBL_ROOM' | translate }}</label
            >
            @if (!showSkeleton) {
              <select-room
                [formGroup]="classViewForm"
                [controlName]="SelectedRoomFormControl"
                [tenantId]="tenantId()"
                [cssClass]="'text-sm w-full'"
                [roomId]="selectedRoomId"
                (selectedRoom)="getSelectedRoomEvent($event)"
              />
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="2.15rem" />
            }
          </div>
        }
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-3">
          <label
            class="font-medium text-700 text-xs mb-2 block uppercase"
            for="comments-textarea"
            >{{
              'SCHEDULE.CREATEAPPOINTMENT.COMMENT' | translate | uppercase
            }}</label
          >
          @if (!showSkeleton) {
            <textarea
              id="comments-textarea"
              pInputTextarea
              class="w-full text-sm h-3rem"
              formControlName="comments"
              #CommentskeyUpInputDelay
              placeholder="{{ 'SCHEDULE.CREATECLASS.ADDCOMMENTS' | translate }}"
              (keyup)="onCommentsKeyUpDelay(CommentskeyUpInputDelay.value)"
            >
            </textarea>
          }
          @if (showSkeleton) {
            <p-skeleton width="100%" height="6rem" />
          }
        </div>
        <!-- Form Group -->

        <!-- Form Group -->
        <div class="mb-2">
          <div class="flex align-items-center">
            @if (!showSkeleton) {
              <p-toggleSwitch
                formControlName="accepts_trial"
                (onChange)="onAcceptTrialChange($event)"
              />
            }
            @if (!showSkeleton) {
              <p class="text-sm mb-0 ml-3 -mt-1">
                {{ 'SCHEDULE.CREATECLASS.ACCEPT_TRIALS' | translate }}
              </p>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }
          </div>
        </div>
        <!-- Form Group -->

        <!-- Row -->
        <div
          class="md:flex flex-wrap justify-content-between relative border-top-1 border-300"
        >
          <div class="my-3 md:w-5 md:pr-3">
            <span class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'SCHEDULE.VIEWAPPOINTMENT.SUBPURPOSE' | translate
            }}</span>
            @if (!showSkeleton) {
              <strong class="block">{{
                classData().subtype_name_primary_language ||
                  classData().subtype_name_secondary_language
              }}</strong>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }
          </div>

          <!-- Form Group -->
          <div class="my-3 md:w-7">
            <span class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'SCHEDULE.VIEWCLASS.CLASS_TYPE' | translate
            }}</span>
            @if (!showSkeleton) {
              <strong class="block"
                ><i
                  class="mr-2 text-600"
                  [ngClass]="selectedBehaviourType!.icon"
                ></i>
                {{ selectedBehaviourType!.name }}
              </strong>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }
          </div>
          <!-- Form Group -->
        </div>
        <!-- Row -->

        <!-- Row -->
        <div
          class="md:flex flex-wrap justify-content-between relative border-top-1 border-300"
        >
          <!-- Form Group -->
          <div
            class="md:mb-0 my-3 pr-3 w-6 md:w-5"
            [ngClass]="
              isClassCompletedOrCancelled
                ? 'opacity-40 pointer-events-none'
                : ''
            "
          >
            <span
              class="font-medium text-700 text-xs mb-0 block uppercase white-space-nowrap"
              >{{ 'SCHEDULE.VIEWCLASS.RESERVATION_LIMIT' | translate }}</span
            >
            @if (!reservationLimitEdit && !showSkeleton) {
              <strong
                (click)="reservationLimitEdit = true"
                class="block cursor-pointer border-round hover:surface-200 p-2 md:w-6rem"
                >{{ GetMaxCapacityFormValue | number }}
              </strong>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }

            @if (reservationLimitEdit) {
              <div class="p-inputgroup md:w-6rem">
                <app-shared-input-number
                  [formGroup]="classViewForm"
                  [controlName]="MaxCapacityFormControl"
                  [styleClass]="'w-full text-sm'"
                  [conditionToFormat]="false"
                  [mode]="'number'"
                />
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-times text-xl"
                  class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                  (click)="EditMaxCapacity(false)"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-check"
                  class="p-button-secondary"
                  (click)="reservationLimitEdit = false; EditMaxCapacity(true)"
                ></button>
              </div>
            }
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div
            class="md:mb-0 my-3 md:pr-3 w-6 md:w-3"
            [ngClass]="
              isClassCompletedOrCancelled
                ? 'opacity-40 pointer-events-none'
                : ''
            "
          >
            <span class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'SCHEDULE.VIEWCLASS.WAIT_LIST' | translate
            }}</span>
            @if (!waitListEdit && !showSkeleton) {
              <strong (click)="waitListEdit = true">
                {{ GetMaxWaitListFormValue | number }}
              </strong>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }

            @if (waitListEdit) {
              <div class="p-inputgroup md:w-5rem relative z-2">
                <app-shared-input-number
                  [formGroup]="classViewForm"
                  [controlName]="MaxWaitListFormControl"
                  [styleClass]="'w-full text-sm'"
                  [conditionToFormat]="false"
                  [mode]="'number'"
                />
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-times text-xl"
                  class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
                  (click)="EditMaxWaitlist(false)"
                ></button>
                <button
                  type="button"
                  pButton
                  pRipple
                  icon="fa fa-check"
                  class="p-button-secondary"
                  (click)="EditMaxWaitlist(true)"
                ></button>
              </div>
            }
          </div>
          <!-- Form Group -->

          <!-- Form Group -->
          <div class="md:pr-3 my-3 w-12 md:w-4">
            <span class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'SCHEDULE.VIEWCLASS.DROP_IN' | translate
            }}</span>
            @if (!showSkeleton) {
              <p-select
                [options]="dropIns"
                formControlName="isDropInAllowed"
                optionLabel="name"
                filterBy="name"
                styleClass="md:w-full align-items-center text-sm border-none bg-green-50  p-0 -mt-2 md:w-7rem"
                (onChange)="onDropInChange($event)"
              >
                <ng-template pTemplate="selectedItem">
                  @if (selectedDropin) {
                    <div class="text-sm font-bold">
                      {{ selectedDropin.name }}
                    </div>
                  }
                </ng-template>
                <ng-template let-dropIn pTemplate="item">
                  <div class="text-sm">{{ dropIn.name }}</div>
                </ng-template>
              </p-select>
            }
            @if (showSkeleton) {
              <p-skeleton width="100%" height="1.15rem" />
            }
          </div>
          <!-- Form Group -->
        </div>
        <!-- Row -->
      </form>
    </div>
    <!-- Left Side -->
  </ng-template>
</p-drawer>

<!-- Sidebar -->

<!-- Cancel Class Modal -->
<p-dialog
  [visible]="cancelClassPopup"
  (onHide)="cancelClassPopup = false"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '470px' }"
  styleClass="no-header-modal"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <form [formGroup]="deleteClassForm">
      <!-- Content -->
      <div class="relative text-center px-4 py-5">
        <div
          class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
          (click)="cancelClassPopup = false"
        ></div>

        <i class="fa fa-exclamation-triangle p-error text-7xl mt-5"></i>

        <h4 class="text-base md:text-lg mb-2 mt-5 mb-0 font-bold">
          {{ 'SCHEDULE.VIEWCLASS.CANCEL_CONFIM' | translate }} <br />
          {{
            classData().type_name_primary_language ||
              classData().type_name_secondary_language
          }}
          {{ 'SCHEDULE.VIEWCLASS.FOR' | translate }}
          {{
            this.setFullDate(
              this.classData().recurring_start_date,
              this.classData().start_time,
              false
            ) | datetimeformat: 'mediumDate'
          }}
          ?
        </h4>
      </div>

      <div class="px-4 pt-4 pb-3 border-top-1 border-300">
        <h4 class="font-medium text-700 text-xs mb-2 block uppercase">
          {{ 'SCHEDULE.VIEWCLASS.CANCEL_REASON' | translate }}
        </h4>
        <textarea
          pInputTextarea
          class="w-full text-sm h-7rem mb-3"
          formControlName="cancellation_reason"
          placeholder="{{
            'SCHEDULE.VIEWCLASS.REASON_PLACEHOLDER' | translate
          }}"
        ></textarea>
      </div>

      <!-- Modal Footer -->
      <div
        class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
      >
        <button
          pButton
          pRipple
          type="button"
          [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
          class="p-button-secondary p-button-text text-sm"
          (click)="cancelClassPopup = false"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          [label]="'SCHEDULE.VIEWCLASS.CONTINUE' | translate"
          class="p-button-danger text-sm"
          (click)="CancelClass(deleteClassForm)"
        ></button>
      </div>
      <!-- Modal Footer -->
    </form>
  </ng-template>
</p-dialog>
<!-- Cancel Class Modal -->

<app-rrule
  [visible]="showRRule"
  (onHide)="HideRRule({})"
  [showNeverStop]="true"
  [minimumDate]="minimumDate"
  [rRuleObj]="RRuleObject"
  (hideRrule)="HideRRule($event)"
  (emitRRule)="FetchRRuleData($event)"
/>
